module.exports = __webpack_public_path__ + "img/application-title.5428b065.png";